import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { Icon, Spinner } from '@/shared/ui';

import styles from './TabLabel.module.scss';

type TabLabelProps = {
  label: ReactNode;
  isGenerating: boolean;
  className?: string;
  isRestricted?: boolean;
};

export const TabLabel: FC<TabLabelProps> = ({
  label,
  isGenerating,
  className,
  isRestricted = false,
}) => (
  <span
    className={cn(styles.container, className)}
    data-component="consultation-tab-label"
  >
    {label}
    {isRestricted ? (
      <Icon name="lock" size={16} className={styles.lock} />
    ) : (
      isGenerating && <Spinner size={12} className={styles.spinner} />
    )}
  </span>
);
